import React from 'react';
import { withStyles, Grid, Typography } from '@material-ui/core';

const ICON_NO_DATA = require("../../images/bg/nodata.png");



class MNoLiving extends React.Component {

    render() {
        const { title } = this.props;
        return (
            <Grid container justify='center' alignItems='center' direction='column'>
                <img src={ICON_NO_DATA} style={{ width: 175, height: 140 }}></img>
                <Typography style={{ color: '#C5C5C5', fontSize: 14 }}>{title ? title : '暂无数据'}</Typography>
            </Grid>
        );
    }

}

export default withStyles((theme) => ({

}))(MNoLiving);